import { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router';
import i18n from '@/i18n';
import { SUPPORTED_LANGUAGES } from '@/i18n';
import ErrorPage from '@/pages/ErrorPage/ErrorPage';
import { useTranslation } from 'react-i18next';
import { useExpoStructure } from '@/api/useExpoStructure';

export default function LangGuard() {
    const { t } = useTranslation();
    const { lang } = useParams();
    const [ready, setReady] = useState(false);

    // Fetch the navigation structure once per language and populate the store.
    const { error: structureError } = useExpoStructure();

    const isValidLang = lang && SUPPORTED_LANGUAGES.includes(lang);

    useEffect(() => {
        if (!isValidLang) return;

        const setLanguage = async () => {
            if (i18n.language !== lang) {
                await i18n.changeLanguage(lang);
            }
            document.documentElement.lang = lang;
            setReady(true);
        };
        setReady(false);
        setLanguage();
    }, [lang, isValidLang]);

    if (!isValidLang) {
        return <ErrorPage />;
    }

    if (!ready) {
        return <div role="status">{`${t('loading')}...`}</div>;
    }

    if (structureError) {
        return <ErrorPage error={503} />;
    }

    return <Outlet />;
}
